import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { environment } from '@env/environment';
import { switchMap, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { User } from '@app/core/business/user/user';
import { UserService } from '@app/core/business/user/user.service';
//import { CookieService } from 'ngx-cookie';
import cssVars from 'css-vars-ponyfill';

@Injectable()
export class AuthenticationService {
  public isConnected$: BehaviorSubject<boolean>;
  public refreshing = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    //private cookieService: CookieService
  ) {

    var token = localStorage.getItem('token');
    var isConnected: boolean;
    if (token)
      isConnected = true;
    else
      isConnected = false;
    this.isConnected$ = new BehaviorSubject(isConnected);
  }

  public setToken(token): void {
    localStorage.setItem('token', token);
  }


  public login(username: string, password: string, rememberMe): Observable<any> {

    // On défini X-API-Name pour la GateWay
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http
      .post(`${environment.baseApiUrl}/authenticate`, {
        username: username,
        password: password,
        rememberMe: rememberMe
      },
        { headers, withCredentials: true })
      .pipe(
        tap((response: any) => {
          localStorage.setItem('token', response.jwt);
          localStorage.setItem('userCode', username)
          localStorage.setItem('rememberMe', rememberMe ? 'true' : 'false');
          this.isConnected$.next(true);


        })

      );
  }



  public setIsConnectedTempo(isConnected: boolean) {
    this.isConnected$.next(isConnected);
  }

  public requestNewCustomer(name: string, email: string, telephone: string, reason: string) {
    const params = new HttpParams()
      .set('name', name)
      .set('email', email)
      .set('telephone', telephone)
      .set('reason', reason);

    return this.http
      .get(`${environment.baseApiUrl}/Customers/Subscribe`, { params: params });
  }

  public passwordResetRequest(username: string): Observable<any> {

    return this.http.post(
      `${environment.baseApiUrl}/authentication/password/lost`,
      {
        username: username,
      }
    );
  }

  public resetPassword(
    token: string,
    newPassword: string,
    repeatNewPassword
  ): Observable<any> {
    return this.http.post(
      `${environment.baseApiUrl}/authentication/password/reset`,
      {
        newPassword: newPassword,
        repeatNewPassword: repeatNewPassword,
      },
      {
        params: {
          token: token,
        },
      }
    );
  }

  public isLoggedIn(): boolean {
    return this.isConnected$.value;
  }

  public checkConnection() {
    return this.isConnected$.getValue() && localStorage.getItem('userCode') !== null;
  }

  public disableImpersonation(): Observable<any> {
    return this.http
      .get(`${environment.baseApiUrl}/Authentication/disableImpersonation`)
      .pipe(
        tap(response => {
          localStorage.setItem('token', response.jwt);
          //localStorage.setItem('token', response.jwt);
          localStorage.setItem('userCode', localStorage.getItem('oldUserCode'));
          localStorage.removeItem('oldUserCode');
          //return this.userService.getUser(null).pipe(tap(user => localStorage.setItem('userCode', user.code)));
          this.isConnected$.next(true);
        })
      );
  }

  public getToken(): string {
    return localStorage.getItem('token');
    //return localStorage.getItem('token');
  }

  /**
   * Déconnexion de l'utilisateur
   * COMMENTAIRE JDU: Je n'aime vraiment pas l'utilisation de localStorage.clear. On perd des infos potentiellement utiles (ex: le rememberMe).
   * Pour l'instant je garde rememberMe mais à revoir.
   */
  public logout(withApiCall = true): void {

    const logoutObs = withApiCall ? this.http.post(`${environment.baseApiUrl}/Authentication/Logout`, {}) : of();
    logoutObs.subscribe({
      next: () => {
        const rememberMe = localStorage.getItem('rememberMe');
        localStorage.clear();
        if (rememberMe) {
          localStorage.setItem('rememberMe', rememberMe);
        }

        if (rememberMe) {
          localStorage.setItem('rememberMe', rememberMe);
        }
        cssVars(environment.cssVarsOptions);
        this.isConnected$.next(false);
        this.router.navigateByUrl('/login');
      },
      error: () => {
        // même si erreur, on nettoie côté client
        localStorage.clear();
        this.router.navigateByUrl('/login');
      }
    });
  }
}
